import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import {
  getAuthGlassCardSx,
  getAuthPageOuterSx,
} from "./authGlassStyles";

/**
 * Shared chrome for /login, /signup, /forgetPsw:
 * full-bleed background + single frosted glass card.
 *
 * Card is statically positioned near the top on mobile so it sits
 * naturally above the keyboard without any JS or animation.
 * overscrollBehavior: none prevents iOS rubber-band bounce.
 */
export default function AuthPageLayout({ children, footer }) {
  const theme = useTheme();

  React.useEffect(() => {
    const prev = document.body.style.overscrollBehavior;
    document.body.style.overscrollBehavior = "none";
    return () => {
      document.body.style.overscrollBehavior = prev;
    };
  }, []);

  return (
    <Box component="main" sx={getAuthPageOuterSx()}>
      <Container
        maxWidth="xs"
        sx={{
          px: { xs: 2, sm: 3 },
          width: "100%",
        }}
      >
        <Paper elevation={0} sx={getAuthGlassCardSx(theme)}>
          {children}
        </Paper>
        {footer}
      </Container>
    </Box>
  );
}
